/**
 * API types
 */
export const ApiMessageTypes = {
    Error: "error",
    Markdown: "markdown",
    Table: "table",
    GenerateSpreadsheet: "generateSpreadsheet",
};

export const ApiDocumentTypes = {
    Drawing: "Drawing",
};

export interface ApiUser {
    id: string;
    email: string;
    name: string;
}

export interface ApiFile {
    id: string;
    createdAt: Date;
    fileName: string;
    fileSize: number;
    fileUrl: string;
    fragmentNodes?: ApiFragmentNode[];
}

export interface ApiFragmentNode {
    id: string;
    fileId: string;
    bounds: ApiBounds;
    title: string;
    hierarchyId: string;
    documentType?: string;
    distance?: number;
    embeddingText?: string;
}

export interface ApiConnection {
    description: string;
    srcFileId: string;
    srcBounds: ApiBounds;
    dstFileId: string;
    dstBounds: ApiBounds;
}

export interface ApiElementsResponse {
    fragment_nodes: ApiFragmentNode[];
    connections: ApiConnection[];
}

export interface ApiConstructabilityIssue {
    id: string;
    node1: ApiFragmentNode;
    node2: ApiFragmentNode;
    title: string;
    category: string;
    severity: string;
    description: string;
    issueNumber: number;
    status?: string;
    ballInCourt?: string;
    statusChangedByUser?: ApiUser;
    statusChangedAt?: string;
}

export interface ApiConversation {
    id: string;
    createdAt: Date;
    updatedAt: Date;
    user: ApiUser;
    title: string;
    messages: ApiMessage[];
}

export interface ApiMessage {
    id: string;
    createdAt: Date;
    message: string;
    messageType: string;
    references: Map<string, ApiReference> | null;
    user: ApiUser;
    conversationId: string;
    parentId: string | null;
    files: ApiFile[];
    fragmentNode?: ApiFragmentNode;
    response?: ApiMessage | null;
    quality?: string | null;
    feedback?: string | null;
    requestId?: string | null;
}

export interface ApiBounds {
    page: number;
    xMin: number;
    yMin: number;
    xMax: number;
    yMax: number;
}

export interface ApiReference {
    fileId: string;
    sectionPath: Array<string>;
    bounds: Map<string, ApiBounds>;
}

export interface SpreadsheetColumn {
    title: string;
    description: string;
}

export interface GenerateSpreadsheetArgs {
    dataToExtract: string;
    columns: SpreadsheetColumn[];
}

/**
 * Parsing
 */
export interface ContentPart {
    isReference: boolean;
    rawContent: string;
}

export type Cell = ContentPart[];
